//import hook react
import React, { useState, useEffect, useRef } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

//import axios
import axios from 'axios';

//import components
import NavBar from '../components/NavBar';
import SearchForm from '../components/SearchForm';
import UserForm from '../components/UserForm';
import UploadUserData from '../components/UploadUserData';

function UserManagement() {
    //state 
    const [user, setUser] = useState({});
    const [searchFormState, setSearchFormState] = useState(false);
    const [userFormState, setUserFormState] = useState(false);

    //define history
    const history = useHistory();

    //token
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);

    //function "fetchData"
    const fetchData = async () => {

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        //fetch user from Rest API
        await axios.get(process.env.REACT_APP_API_URL + '/api/user')
            .then((response) => {

                //set response user to state
                setUser(response.data);
                setSearchFormState(true);
                setUserFormState(true);
            })
    }

    //hook useEffect
    useEffect(() => {

        //check token empty
        if (!token) {

            //redirect login page
            history.push('/');
        }
        else {

            //call function "fetchData"
            fetchData();
        }

    }, []);

    return (
        <div className="container" style={{ marginTop: "50px" }}>
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="card border-0 rounded shadow-sm">
                        <div className="card-body outbox">
                            <div className='row'>
                                <div className='col-md-12 text-right'>
                                    <NavBar user={user}></NavBar>
                                </div>
                            </div>
                            <hr />

                            <Tabs
                                defaultActiveKey="profile"
                                id="uncontrolled-tab-example"
                                className="mb-3"
                            >
                                <Tab eventKey="profile" title="Profile">
                                    <UserForm state={userFormState} user={user}></UserForm>
                                </Tab>
                                
                                {((user.user_type == 'ADMIN') || (user.user_type == 'SUPERADMIN')) &&
                                        <Tab eventKey="search" title="Search">
                                            <SearchForm state={searchFormState} user_type={user.user_type}></SearchForm>
                                        </Tab>
                                }
                                
                                {((user.user_type == 'ADMIN') || (user.user_type == 'SUPERADMIN')) &&
                                        <Tab eventKey="upload" title="Upload">
                                            <UploadUserData></UploadUserData>
                                        </Tab>
                                }
                            </Tabs>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default UserManagement;